import { createSystem, defaultConfig } from '@chakra-ui/react'

import { breakpoints } from './breakpoints'
import { globalStyles } from './styles'
import { textStyles } from './text'

export const system = createSystem(defaultConfig, {
  theme: {
    breakpoints: breakpoints,
    textStyles: textStyles,
    tokens: {
      colors: globalStyles.colors
    }
  }
})
